import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { post_ForgotPasswordMember } from '../../services/ForgotPassword';
import EmailValidatedComponent from '../../components/EmailValidatedComponent';
import { checkServerHealth } from '../../services/Health';

const MemberForgotPassword = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState<any>({
        emailAddress: "",
    });
    const [message, setMessage] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        wakeUpServer();
    }, []);

    const wakeUpServer = async () => {
        const isAlive = await checkServerHealth();

        if (isAlive) console.log("Server is alive");
        else console.log("Server unavailable");
    }

    const waitForServer = async () => {
        const delay = 5000; // check every 5 seconds

        while (true) {
            try {
                const isAlive = await checkServerHealth();

                if (isAlive) {
                    console.log("Server is alive");
                    return true;
                }

                console.log("Server not ready, retrying...");
            } catch (error) {
                console.log("Health check error, retrying...");
            }

            await new Promise(resolve =>
                setTimeout(resolve, delay)
            );
        }
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (isProcessing) return;

        setIsProcessing(true);
        setMessage('');
        setErrorMessage('');


        const serverAlive = await waitForServer();
        if (serverAlive) {
            post_ForgotPasswordMember(userData.emailAddress)
                .then((res) => {
                    if (res === userData.emailAddress) {
                        setMessage(`We've emailed a link to ${userData.emailAddress} to let you update your password. 
                        If you don't see the email, be sure to check your spam and junk mail folders.`);
                        setIsSuccess(true);
                    } else {
                        setErrorMessage('Your email address does not exist.');
                    }
                    setIsProcessing(false);
                    setUserData({ emailAddress: '' });
                })
                .catch((error) => {
                    if (error.response && error.response.status === 500) {
                        setErrorMessage('There is some problem occurring. Please try again later.');
                    } else if (error.response?.data === 'User account is disabled.') {
                        setErrorMessage('Your account has been disabled. Please contact the administrator.');
                    } else {
                        setErrorMessage('Your email address does not exist.');
                    }
                    console.error(error);
                    setIsProcessing(false);
                });
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center">Forgot Password</h2>
                {!isSuccess ? (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <EmailValidatedComponent
                                text={userData.emailAddress}
                                setText={(value) =>
                                    setUserData({ ...userData, emailAddress: value })
                                }
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={isProcessing}
                            className={`w-full ${isProcessing ? 'bg-gray-500' : 'bg-custom-blue hover:bg-blue-900'} text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
                        >
                            {isProcessing ? 'Processing...' : 'Reset Password'}
                        </button>
                    </form>
                ) : (
                    <div className="text-center">
                        <div className="my-4 text-blue-900">{message}</div>
                        <button onClick={() => navigate("/sign-in")}
                            className="mt-4 bg-custom-blue hover:bg-blue-900 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                            Go back to sign in
                        </button>
                    </div>
                )}
                {errorMessage && (
                    <div className="mt-4 text-center text-red-500">
                        {errorMessage}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MemberForgotPassword;